import React, { useMemo, memo, useCallback } from 'react';
import { Checkbox } from 'antd';
import { Typography } from 'components/common';
import { Utils } from 'utils';
import './departmentListItem.scss';

export interface MockDepartment {
  id: string;
  name: string;
  extension: string;
  agentCount: number;
  answeredCalls: number;
  waitingCalls: number;
  availableAgents: number;
}

interface DepartmentListItemProps {
  department: MockDepartment;
  isSelected?: boolean;
  onToggle?: () => void;
}

const DOT_COLOR_AVAILABLE = '#52c41a';
const DOT_COLOR_UNAVAILABLE = '#ff4d4f';
const ICON_SIZE = '14px';
const FONT_WEIGHT = 500;

const DepartmentListItem: React.FC<DepartmentListItemProps> = ({
  department,
  isSelected = false,
  onToggle
}) => {
  const color = useMemo(
    () => Utils.generateNameSpaceColor(department.name),
    [department.name]
  );
  
  const dotColor = useMemo(
    () => department.availableAgents > 0 ? DOT_COLOR_AVAILABLE : DOT_COLOR_UNAVAILABLE,
    [department.availableAgents]
  );

  const handleCheckboxClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  const nameStyle = useMemo(() => ({ color }), [color]);
  const fontWeightStyle = useMemo(() => ({ fontWeight: FONT_WEIGHT }), []);
  const iconStyle = useMemo(() => ({ fontSize: ICON_SIZE }), []);
  const dotStyle = useMemo(() => ({ backgroundColor: dotColor }), [dotColor]);

  return (
    <div className="department-row">
      <Checkbox
        checked={isSelected}
        onChange={onToggle}
        onClick={handleCheckboxClick}
        className="department-checkbox"
      />
      
      <div className="department-name" style={nameStyle}>
        <Typography variant="subHeading-1" style={fontWeightStyle}>
          {department.name}
        </Typography>
      </div>

      <div className="department-stats">
        <div className="department-stat">
          <i className="bx bxs-phone" style={iconStyle} />
          <Typography variant="small-text-4">{department.answeredCalls}</Typography>
        </div>

        <div className="department-stat">
          <div className="department-dot" style={dotStyle} />
          <Typography variant="small-text-4">{department.availableAgents}</Typography>
        </div>

        <div className="department-stat">
          <i className="bx bx-group" style={iconStyle} />
          <Typography variant="small-text-4">{department.agentCount}</Typography>
        </div>
      </div>
    </div>
  );
};

export default memo(DepartmentListItem);
